<div class="modal-header">
  <h4 class="modal-title"
      [translate]="pointOfSale ? 'services.pointOfSale.modal.modifyTitle' : 'services.pointOfSale.modal.addTitle'"></h4>

  <button class="btn-close" aria-label="Close"
          (click)="activeModal.dismiss('Cross click')">
  </button>
</div>

<div class="modal-body">
  <form name="pointOfSaleForm" [formGroup]="pointOfSaleForm">
    <div class="row">

      <!-- PosId -->
      <div class="col-12">
        <label class="form-label" for="posId">{{ 'services.pointOfSale.modal.posId' | translate }}*</label>
        <input class="form-control" id="posId" type="text" name="posId" maxlength="50"
               [formControl]="posId"
               pattern="{{ FormUtils.textInputPattern }}"
               placeholder="{{ 'services.pointOfSale.modal.posId' | translate }}"
               required>
        <app-form-error [control]="posId"></app-form-error>
      </div>

      <!-- Name -->
      <div class="col-12 col-md-6">
        <label class="form-label" for="nameFR">{{ 'services.pointOfSale.modal.nameFR' | translate }}*</label>
        <input class="form-control" id="nameFR" type="text" name="nameFR" maxlength="50"
               [formControl]="nameFR"
               pattern="{{ FormUtils.textInputPattern }}"
               placeholder="{{ 'services.pointOfSale.modal.nameFR' | translate }}"
               required>
        <app-form-error [control]="nameFR"></app-form-error>
      </div>

      @if (customerConfigService.isLanguageAvailable('de')) {
        <div class="col-12 col-md-6">
          <label class="form-label" for="nameDE">{{ 'services.pointOfSale.modal.nameDE' | translate }}</label>
          <input class="form-control" id="nameDE" type="text" name="nameDE" maxlength="50"
                 [formControl]="nameDE"
                 pattern="{{ FormUtils.textInputPattern }}"
                 placeholder="{{ 'services.pointOfSale.modal.nameDE' | translate }}">
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('it')) {
        <div class="col-12 col-md-6">
          <label class="form-label" for="nameIT">{{ 'services.pointOfSale.modal.nameIT' | translate }}</label>
          <input class="form-control" id="nameIT" type="text" name="nameIT" maxlength="50"
                 [formControl]="nameIT"
                 pattern="{{ FormUtils.textInputPattern }}"
                 placeholder="{{ 'services.pointOfSale.modal.nameIT' | translate }}">
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('en')) {
        <div class="col-12 col-md-6">
          <label class="form-label" for="nameEN">{{ 'services.pointOfSale.modal.nameEN' | translate }}</label>
          <input class="form-control" id="nameEN" type="text" name="nameEN" maxlength="50"
                 [formControl]="nameEN"
                 pattern="{{ FormUtils.textInputPattern }}"
                 placeholder="{{ 'services.pointOfSale.modal.nameEN' | translate }}">
        </div>
      }

      <!-- Description -->
      <div class="col-12 col-md-6">
        <label class="form-label">{{ 'services.pointOfSale.modal.descriptionFR' | translate }}</label>
        <textarea class="form-control" id="descriptionFR"
                  placeholder="{{ 'services.pointOfSale.modal.descriptionFR' | translate }}"
                  maxLength="100" rows="3"
                  [formControl]="descriptionFR"
                  pattern="{{ FormUtils.textInputPattern }}"></textarea>
      </div>

      @if (customerConfigService.isLanguageAvailable('de')) {
        <div class="col-12 col-md-6">
          <label class="form-label">{{ 'services.pointOfSale.modal.descriptionDE' | translate }}</label>
          <textarea class="form-control" id="descriptionDE"
                    placeholder="{{ 'services.pointOfSale.modal.descriptionDE' | translate }}"
                    maxLength="100" rows="3"
                    [formControl]="descriptionDE"
                    pattern="{{ FormUtils.textInputPattern }}"></textarea>
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('it')) {
        <div class="col-12 col-md-6">
          <label class="form-label">{{ 'services.pointOfSale.modal.descriptionIT' | translate }}</label>
          <textarea class="form-control" id="descriptionIT"
                    placeholder="{{ 'services.pointOfSale.modal.descriptionIT' | translate }}"
                    maxLength="100" rows="3"
                    [formControl]="descriptionIT"
                    pattern="{{ FormUtils.textInputPattern }}"></textarea>
        </div>
      }

      @if (customerConfigService.isLanguageAvailable('en')) {
        <div class="col-12 col-md-6">
          <label class="form-label">{{ 'services.pointOfSale.modal.descriptionEN' | translate }}</label>
          <textarea class="form-control" id="descriptionEN"
                    placeholder="{{ 'services.pointOfSale.modal.descriptionEN' | translate }}"
                    maxLength="100" rows="3"
                    [formControl]="descriptionEN"
                    pattern="{{ FormUtils.textInputPattern }}"></textarea>
        </div>
      }

    </div>
  </form>
</div>

<div class="modal-footer">
  <button class="btn btn-outline-secondary"
          (click)="activeModal.close()"
          translate="common.cancel">
  </button>

  <button type="submit" class="btn btn-primary"
          [disabled]="pointOfSaleForm.invalid"
          (click)="addOrUpdatePointOfSale()"
          translate="common.save">
  </button>
</div>
